import $ from 'jquery';
import 'slick-carousel';

function unitSliderInit() {
    var $status     = $('.c-unit_slider--count'),
        $slider     = $('.c-unit_slider');  
          
    $slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i + '/' + slick.slideCount);
    });

	$slider.slick({
		arrows: true,
		autoplay: false,
		autoplaySpeed: 8000,
		infinite: true,
        dots: false,
        rows: 0,
        prevArrow: '<button type="button" class="c-unit_slider--arrow-prev"></button>',
        nextArrow: '<button type="button" class="c-unit_slider--arrow-next"></button>',
	});
}

function unitSliderDestroy() {
    var $slider = $('.c-unit_slider');  
    
    $slider.slick('unslick');
}

export { unitSliderInit, unitSliderDestroy };